import script from "./FordExtraVinLimitCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FordExtraVinLimitCard.vue?vue&type=script&setup=true&lang=js"

import "./FordExtraVinLimitCard.vue?vue&type=style&index=0&id=3caa0572&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3caa0572"]])

export default __exports__